module.exports = __webpack_public_path__ + "img/discord.f3f79d21.svg";